/* jshint ignore:start */

var TabsManager = (function ($) {
    var instance;

    function init() {

        function openContent(tabName, index) {
            $('.js-tab-content').hide();
            $('#news_content_' + index).show();

            $('.js-tabs-hover').removeClass('active');
            $('#' + tabName).addClass('active');
        }


        return {

            init: function () {

                var $linksDisables = $('.js-tabs-hover');
                if ($linksDisables.length) {

                    $linksDisables.hover(                        
                        function () {
                            var tabId = $(this).attr('id');
                            var tabIndex = $(this).data('index');
                            console.log('HOLA AMIGOS2...', tabId, tabIndex);
                            openContent(tabId, tabIndex);
                        }, function () {
                            
                        }
                    );
                }
            }
        };
    }


    return {

        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

